module.exports = __webpack_public_path__ + "img/public.084e8d83.svg";